import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';

import {i18n_resources} from '@/i18n/i18n_resources';
import {isDevelopment} from '@/utils/environment';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: i18n_resources,
    lng: 'en',
    debug: isDevelopment,
    keySeparator: '.',
    interpolation: {
      escapeValue: true,
    },
  });

export default i18n;
